import security from "./security";
import master from "./master";
import notification from "./notification";
import transaction from "./transaction";
import ws from "./ws";

export default {
    security: {
        namespaced: true,
        modules: {
            ...security
        }
    },
    master: {
        namespaced: true,
        modules: {
            ...master
        }
    },
    notification: {
        namespaced: true,
        modules: {
            ...notification
        }
    },
    transaction: {
        namespaced: true,
        modules: {
            ...transaction
        }
    },
    ws: {
        namespaced: true,
        modules: {
            ...ws
        }
    }
};
